var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity-login" }, [
    _c(
      "div",
      { staticClass: "activity-login__wrap" },
      [
        _c("p", { staticClass: "activity-login__title" }, [
          _vm._v("\n      Login Activity\n    ")
        ]),
        _vm._v(" "),
        !_vm.isLoading &&
        _vm.logActivityLoginList &&
        _vm.logActivityLoginList.length > 0
          ? [
              _c(
                "div",
                { staticClass: "activity-login__content" },
                _vm._l(_vm.logActivityLoginList, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "activity-login__item shadow-sm"
                    },
                    [
                      _c("div", { staticClass: "activity-login__item__left" }, [
                        _c("div", [
                          item.device_type === "mobile"
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/icon/phone.svg"),
                                  alt: "device"
                                }
                              })
                            : item.device_type === "web"
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/icon/laptop.svg"),
                                  alt: "device"
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/icon/unknown-device.svg"),
                                  alt: "device"
                                }
                              })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "activity-login__item__info" },
                          [
                            _c(
                              "p",
                              { staticClass: "activity-login__item__title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.registered_device || "Unknown device"
                                    ) +
                                    "\n                " +
                                    _vm._s(
                                      item.operating_system
                                        ? "(" + item.operating_system + ")"
                                        : "(Unknown OS)"
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "activity-login__item__subtitle" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm
                                        .$moment(item.login_time)
                                        .format("D MMMM YYYY HH:mm:ss")
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.status === 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "activity-login__item__button btn",
                                    on: {
                                      click: function($event) {
                                        _vm.onClickLogout(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Logout\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "activity-login__item__status",
                          class: { green: item.status === 1 }
                        },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(item.status === 1 ? "Active" : "Inactive")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                })
              )
            ]
          : _vm.isLoading
          ? [_c("j-skeleton-log-activity-login")]
          : _c("div", [_c("p", [_vm._v("No Data")])]),
        _vm._v(" "),
        _c("div", { staticClass: "activity-login__pagination" }, [
          _c("div", { staticClass: "custom-pagination" }, [
            _c(
              "div",
              {
                staticClass: "btn-previous",
                class: { disabled: _vm.isDisabledPrevPage },
                on: { click: _vm.onClickPrevPage }
              },
              [_c("i", { staticClass: "fa fa-chevron-left" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn-forward",
                class: { disabled: _vm.isDisabledNextPage },
                on: { click: _vm.onClickNextPage }
              },
              [_c("i", { staticClass: "fa fa-chevron-right" })]
            )
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae8919fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae8919fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/log-activity/jLogActivityLogin.vue
// module id = null
// module chunks = 